// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../admin/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Bulma Utilities */\n@media screen and (min-width: 769px) {\na[href*=\"tel:\"] {\n    cursor: default;\n    pointer-events: none;\n    color: hsl(0deg, 0%, 29%);\n}\n}\n.report-layout__section {\n  margin-bottom: 1.875em;\n  padding-bottom: 1rem;\n}\n.report-layout__section:first-child {\n  margin-top: 2.875rem;\n}\n.report-layout__title {\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin-bottom: 1rem;\n}", ""]);
// Exports
module.exports = exports;
